import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=5ec05b22"
import script from "./NewsList.vue?vue&type=script&lang=ts"
export * from "./NewsList.vue?vue&type=script&lang=ts"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=5ec05b22&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports